import React from 'react';
import { Clock, HelpCircle, TrendingDown, CalendarX } from 'lucide-react';
import { problemsData } from '../data/mock';

const iconMap = {
  clock: Clock,
  'help-circle': HelpCircle,
  'trending-down': TrendingDown,
  'calendar-x': CalendarX,
};

const Problems = () => {
  return (
    <section className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-[#013139] mb-4">
            ¿Te suena alguna de estas situaciones?
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            Si has sentido alguna de estas frustraciones, estás en el lugar correcto
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8 max-w-5xl mx-auto">
          {problemsData.map((problem) => {
            const IconComponent = iconMap[problem.icon];
            return (
              <div
                key={problem.id}
                className="group relative bg-gradient-to-br from-gray-50 to-white p-8 rounded-2xl border-2 border-gray-100 hover:border-[#00E5A3] transition-all duration-300 hover:shadow-xl"
              >
                <div className="absolute top-0 right-0 w-32 h-32 bg-[#00E5A3]/5 rounded-bl-full opacity-0 group-hover:opacity-100 transition-opacity" />
                
                <div className="relative">
                  <div className="w-14 h-14 bg-[#013139] group-hover:bg-[#00E5A3] rounded-xl flex items-center justify-center mb-6 transition-colors">
                    <IconComponent className="text-white group-hover:text-[#013139] transition-colors" size={28} />
                  </div>

                  <h3 className="text-2xl font-bold text-[#013139] mb-4">
                    {problem.title}
                  </h3>

                  <p className="text-gray-600 leading-relaxed">
                    {problem.description}
                  </p>
                </div>
              </div>
            );
          })}
        </div>

        {/* CTA */}
        <div className="mt-16 text-center">
          <p className="text-xl text-[#013139] font-semibold mb-4">
            No estás solo. Yo te ayudo a resolver todo esto.
          </p>
          <button
            onClick={() => {
              document.getElementById('contacto').scrollIntoView({ behavior: 'smooth' });
            }}
            className="text-[#00E5A3] hover:text-[#00C497] font-semibold text-lg underline underline-offset-4"
          >
            Hablemos de tu situación →
          </button>
        </div>
      </div>
    </section>
  );
};

export default Problems;
